/*
  RCREA | Güten Brew - Collection Badges Carousel
  Archivo: rcrea-guten-collection-badges.js
  Descripción: Control de flechas para scroll horizontal de badges.
*/

(function () {
  function initRcreaGutenBadges(section) {
    const track = section.querySelector("[data-rcrea-badges-track]");
    const prev = section.querySelector("[data-rcrea-badges-prev]");
    const next = section.querySelector("[data-rcrea-badges-next]");
    const badgesCount = Number(section.dataset.rcreaBadgesCount || 0);

    if (!track) return;

    /*
      Si hay 6 badges o menos, no se inicializa carrusel.
      Los ítems quedan centrados por CSS.
    */
    if (badgesCount <= 6) {
      section.classList.add("rcrea-guten-badges--centered");
      section.classList.remove("rcrea-guten-badges--carousel");
      return;
    }

    if (!prev || !next) return;

    if (section.dataset.rcreaBadgesInitialized === "true") {
      return;
    }

    section.dataset.rcreaBadgesInitialized = "true";

    function getScrollAmount() {
      const firstItem = track.querySelector(".rcrea-guten-badges__item");

      if (!firstItem) return 300;

      const itemWidth = firstItem.getBoundingClientRect().width;
      const trackStyles = window.getComputedStyle(track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);

      return (itemWidth + gap) * 2;
    }

    function updateArrows() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      const currentScroll = track.scrollLeft;

      if (maxScrollLeft <= 4) {
        prev.classList.add("is-disabled");
        next.classList.add("is-disabled");
        return;
      }

      prev.classList.toggle("is-disabled", currentScroll <= 4);
      next.classList.toggle("is-disabled", currentScroll >= maxScrollLeft - 4);
    }

    prev.addEventListener("click", function () {
      track.scrollBy({
        left: -getScrollAmount(),
        behavior: "smooth"
      });
    });

    next.addEventListener("click", function () {
      track.scrollBy({
        left: getScrollAmount(),
        behavior: "smooth"
      });
    });

    track.addEventListener("scroll", updateArrows, { passive: true });

    window.addEventListener("resize", function () {
      window.requestAnimationFrame(updateArrows);
    });

    window.requestAnimationFrame(updateArrows);
    setTimeout(updateArrows, 300);
  }

  function initAllRcreaGutenBadges() {
    document
      .querySelectorAll(".rcrea-guten-badges")
      .forEach(initRcreaGutenBadges);
  }

  document.addEventListener("DOMContentLoaded", initAllRcreaGutenBadges);

  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target.querySelector(".rcrea-guten-badges");

    if (section) {
      delete section.dataset.rcreaBadgesInitialized;
      initRcreaGutenBadges(section);
    }
  });
})();